












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { SimpleHttpAdapterImpl } from "~/backend/SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { stringifyParams } from "~/utils/stringifyParams";

import { ListContentAndApprovalsResponse } from "../model/listContentAndApprovalsResponse";

import { ContentAndApprovalsService }  from "./contentAndApprovals.serviceInterface";

export class ContentAndApprovalsServiceImpl implements ContentAndApprovalsService {
    private simpleHttpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.simpleHttpAdapter.setIsEdgeSupported();

    }

    
















    public async listContentAndApprovals(pageSize?: number, page?: number, pageToken?: string, sortByDate?: string, sortByContentName?: string, dateCreatedAfter?: string, dateCreatedBefore?: string, contentName?: string, content?: string, language?: Array<string>, contentType?: Array<string>, channelEligibility?: Array<string>, options?: object): Promise<ListContentAndApprovalsResponse> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "contentAndApprovals.service.ts"
        };

        const _queryParams: Record<string, unknown> = { "PageSize": pageSize, "Page": page, "PageToken": pageToken, "SortByDate": sortByDate, "SortByContentName": sortByContentName, "DateCreatedAfter": dateCreatedAfter, "DateCreatedBefore": dateCreatedBefore, "ContentName": contentName, "Content": content, "Language": language, "ContentType": contentType, "ChannelEligibility": channelEligibility };
        const _queryStr = stringifyParams(_queryParams);
        const _url = `https://content[region].twilio.com/v2/ContentAndApprovals${_queryStr ? `?${_queryStr}` : ""}`;
        let response;
        try {
            response = await this.simpleHttpAdapter.get<ListContentAndApprovalsResponse>(_url, AuthenticationMethod.Basic, options);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `ContentAndApprovalsService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }
}

